// extracted by mini-css-extract-plugin
export default {"root":"SupportPanel-module-root","link":"SupportPanel-module-link","picture":"SupportPanel-module-picture","text":"SupportPanel-module-text"};